export class FileUploader {
    static async validateTotalFileSize(files) {
        let currentSize = 0;
        files.map((file) => {
            currentSize += file.size;
        });
        if (currentSize > 100 * 1024 * 1024) {
            return "Total File size exceeds the maximum limit of 100 MB.";
        }
        else {
            return null;
        }
    }
    static async validateFile(file) {
        const fileType = file.name.split(".").pop()?.toLowerCase();
        if (!fileType || !FileUploader.supportedFileTypes.includes(fileType)) {
            return `Invalid file type. Please upload files of supported types:${FileUploader.supportedFileTypes
                .map((type) => ` .${type.toUpperCase()}`)
                .join(",")}`;
        }
        if (file.size > FileUploader.maxTotalFileSizeInMB * 1024 * 1024) {
            return `File size exceeds the maximum limit of ${FileUploader.maxTotalFileSizeInMB} MB.`;
        }
        return null;
    }
    static async getBase64(file) {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                let encoded = reader.result
                    ?.toString()
                    .replace(/^data:(.*,)?/, "");
                if (encoded && encoded.length % 4 > 0) {
                    encoded += "=".repeat(4 - (encoded.length % 4));
                }
                resolve(encoded);
            };
        });
    }
    static async handleUpload(e, onFileUpload) {
        if (e.target && e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            if (onFileUpload) {
                const base64 = await FileUploader.getBase64(file);
                onFileUpload(file, base64);
            }
        }
    }
}
FileUploader.supportedFileTypes = [
    "pdf",
    "doc",
    "docx",
    "xls",
    "xlsx",
    "ppt",
    "pptx",
    "txt",
    "jpeg",
    "jpg",
    "png",
    "gif",
    "csv",
];
FileUploader.maxTotalFileSizeInMB = 100;
